module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Ben_Farrell.19524195.webp";